import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
export const ASSET_NAME = 'our-team';

export const loadData = (params, search) => dispatch => {
  const pageAsset = { ourTeam: `content/pages/${ASSET_NAME}.json` };
  return dispatch(fetchPageAssets(pageAsset, true));
};
